/****
 * This is the App main screen - for a reseller, this is the list of apps configured for customer onboarding.
 * For AppBind, content is TBD.
 */
import React, { Component } from 'react';
import graphql from 'babel-plugin-relay/macro';
import { QueryRenderer } from 'react-relay';
import { Redirect } from 'react-router-dom';
import AbEnvironment from '../auth/AbEnvironment';
import withStyles from '@mui/styles/withStyles';
import { Button, Grid, Paper, TextField, Typography } from '@mui/material';
import VisibilityIcon from '@mui/icons-material/Visibility';

import CommunicationTemplateUpdateMutation from './CommunicationTemplateUpdateMutation';
import CommunicationTemplateCreateMutation from './CommunicationTemplateCreateMutation';
import AccountFetch from '../account/AccountFetch';


import CommunicationTemplatePreviewDialog from './CommunicationTemplatePreviewDialog';
import CommunicationTemplatePreview from './CommunicationTemplatePreview';

import PageTitle from '../ui/PageTitle';
import LoadingSpinner from '../ui/LoadingSpinner';
import ServerError from '../ui/ServerError';
import SaveButton from '../ui/SaveButton';
import AppBindStyles from '../../AppBindStyles';

const abEnvironment = new AbEnvironment();
const CommunicationTemplateQuery = graphql`
query CommunicationTemplateQuery($accountId: UUID!, $templateName: String) {
  allCommunicationTemplateTs(condition: {accountId: $accountId, templateName: $templateName}) {

    nodes {
      ctId
      greeting
      templateName
      body
    }
 }
}
`;

const styleSheet = theme => ({
  root: {
    flexGrow: 1,
    //marginTop: 10,
  },
  flex: {
    flex: 1,
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: 'left',
    color: theme.palette.text.secondary,
    maxWidth: 1200,
    minHeight: 325,
    marginTop: 16,
  },
  selectField: {
    minWidth: 300
  }
});

class CommunicationTemplate extends Component {
  state = {
    body: null,
    greeting: null,
    accountLogo: null,
    forceFetch: 0,
    showPreview: false,
    saveStatus: null,
    saveMessage: null,
    saveSnackbarOpen: false,
    saveSnackbarDuration: null
  };

  componentDidMount() {
    if (abEnvironment.isSegmentActive()) {  window.analytics.track('Setting up a communication template'); }

     //fetch account and see if there is a logo on it to use as default.
     this.fetchAccount();
  }

  /* See if there is an account logo */
  fetchAccount = () => {
    let accountId = abEnvironment.getUserAttribute('a_id');
    AccountFetch.fetch(accountId).toPromise()
    .then(af => {
       if (af.accountTByAccountId) {
        this.setState({accountLogo: af.accountTByAccountId.logo});
       }
    })
    .catch(err => {
      //nothing to do....
    })
  }

  goTo(route) {
    this.props.history.push(`/${route}`);
  }



  handleChange = name => event => {
    this.setState({
      [name]: event.target.value,
    });
  };

  handlePreviewDialogClose = () => {
    this.setState({showPreview: false});
  };
    
  previewClicked = () => {
    this.setState({showPreview: true});         
  }

  getValueForRender(state_member, prop_member, theDefault)
  {
    if (state_member != null)
      return state_member;

    if (prop_member != null)
      return prop_member;

    return theDefault;
  }

  disableTemplateSave(template) {

      //existing
      if ((this.state.greeting === null) && (this.state.body === null)) {
        return true;
      } else { 
        if ((this.state.greeting !== null && this.state.greeting !== template.greeting) || (this.state.body !== null && this.state.body !== template.body)) {
          return false;
        } else {
          return true;
        }
     }
 
 
  }



  render() {
    const { isAuthenticated, isAuthenticatedReseller, isAuthenticatedVendor, needAssent, logError } = this.props.auth;
    const classes = this.props.classes;

    let templateDefaults = [{templateName: "CustInvite",
                             body: "We'd like to purchase and manage subscriptions for your project.\n\nPlease use our client portal to securely link your credit card, debit card, or bank account. Then we can automatically and transparently expense subscriptions to you.",
                            greeting: ""}, 

                            {templateName: "CustStatements",
                             body: "Your monthly statement and a detailed transaction record for the past month is ready to view.",
                             greeting: ""}];

    if (isAuthenticatedVendor()) {
      templateDefaults = [{templateName: "PayoutNotif",
                             body: "A new payout has been made.  You can view your detailed transaction record.",
                             greeting: ""}];
    }

    if ((!isAuthenticated() && !isAuthenticatedVendor()) || needAssent()) {
      return (
        <Redirect to='/home' />
      );
    }

    if (isAuthenticatedReseller() || isAuthenticatedVendor())
    {
      const params = new URLSearchParams(this.props.location.search);
      let templateName = params.get('name');

      let accountId = abEnvironment.getUserAttribute('a_id');
 

      let subTitle = '';
      if (templateName === 'CustInvite') {
        subTitle = 'Customer invite email.';
      } else if (templateName === 'CustStatements') {
        subTitle = 'Customer statement email.';
      } else if (templateName === 'PayoutNotif') {
        subTitle = 'Payout ready email.';
      }

      return (
        <div className={classes.root}>

          <PageTitle title="Email communication" subtitle={subTitle} showBackButton={true} name="Communications" history={this.props.history}/>

          <Paper className={classes.paper}>
            <Grid container spacing={2} direction="row" justifyContent="flex-start">

           <QueryRenderer
                environment={abEnvironment.getEnvironment()}
                query={CommunicationTemplateQuery}
                variables={{accountId: accountId,
                            templateName: templateName,
                            forceFetch: this.state.forceFetch}}
                render={({error, props})=> {
                  if (error) {
                    logError(error.message);
                    return (
                      <ServerError/>
                    );
                } else if (props) {


                    let template = {};

                    // Options from result of query
                    if (props.allCommunicationTemplateTs.nodes.length !== 0) {

                      template = props.allCommunicationTemplateTs.nodes[0];

                    } else {
                      //find default template and display it.
                      

                      for (var i = 0; i < templateDefaults.length; i++) {
                        var templateDefault = templateDefaults[i];
                        if (templateDefault.templateName === templateName) {
                          template = templateDefault;
                          break;
                        }
                      }
                    }

                      return (
                        <React.Fragment>
                          <Grid item>
                            
                            <TextField
                              id="greeting" label="Optional salutation" style={{maxWidth: 150}}
                              value={this.getValueForRender(this.state.greeting, template.greeting, '') }
                              onChange={ (e) => { this.setState({ greeting: e.target.value }); } }
                              inputProps={{ maxLength: 32 }}
                            />
                          </Grid>
                          <Grid item >
                            
                            <Typography variant="subtitle2" color="primary" style={{marginTop: 24}}>[first name], </Typography>
                          </Grid>
  
                          <Grid item xs={12} >
                            <TextField
                              id="body" label="Email Body" 
                              value={this.getValueForRender(this.state.body, template.body, '') }
                              minRows={10}
                              maxRows={5} 
                              fullWidth
                              multiline
                              onChange={ (e) => { this.setState({ body: e.target.value }); } }
                              inputProps={{ maxLength: 2048 }}
                            />
                          </Grid>

                          <Grid item>
                                <SaveButton
                                  snackbarOpen={this.state.saveSnackbarOpen}
                                  autoHideDuration={this.state.saveSnackbarDuration}
                                  onSaveClick={() => { this._updateTemplate(template); }}
                                  onSnackbarClose={() => { this._onSnackbarClose(); }}
                                  status={this.state.saveStatus}
                                  message={this.state.saveMessage}
                                  disabled={this.disableTemplateSave(template)}
                                  />

                                  <Button variant="outlined" color="primary" style={AppBindStyles.bottomButton} onClick={() => { this.previewClicked(); }}>
                                    <VisibilityIcon style={{marginRight: '8px'}} color="primary"/>Preview
                                  </Button>
                          </Grid>
                          
                              <CommunicationTemplatePreviewDialog
                                  title="Communication preview"
                                  open={this.state.showPreview}
                                  onClose={() => { this.handlePreviewDialogClose()}} >

                                    <CommunicationTemplatePreview
                                      templateName={templateName}
                                      logo={this.state.accountLogo}
                                      greeting= {this.getValueForRender(this.state.greeting, template.greeting, '')}
                                      body= {this.getValueForRender(this.state.body, template.body, '')}
                                      onClose={() => { this.handlePreviewDialogClose()}}>
                                    </CommunicationTemplatePreview>

                                </CommunicationTemplatePreviewDialog>

                        </React.Fragment>
                      );

                     
                  }
                  return (
                    <div>
                      <Typography>Loading...</Typography>
                      <LoadingSpinner/>
                    </div>
                  );
                }}
              />
            </Grid>
          </Paper>
        </div>

      );
    }
    else
    {
      return (
        <Redirect to='/home' />
      );
    }
  }


  _onSnackbarClose() {
    this.setState( {saveSnackbarOpen: false, saveStatus: '', saveMessage: '', saveSnackbarDuration: null });
  }

  _updateTemplate(template) {
    this.setState({ saveStatus: 'saving' });

    let forceFetch = this.state.forceFetch;
    forceFetch++;

    let accountId = abEnvironment.getUserAttribute('a_id');

    if (template.ctId) {

      CommunicationTemplateUpdateMutation.commit(template.ctId, accountId, this.state.usingAccountId, template.templateName, this.state.greeting, this.state.body)
      .then(response => {
         this.setState({ forceFetch: forceFetch, showSpinner: false, saveSnackbarOpen: true, saveStatus: 'success', saveMessage: 'Template saved.', saveSnackbarDuration: 3000 });
      })
      .catch(error => {
         this.setState({ showSpinner: false, saveSnackbarOpen: true, saveStatus: 'error', saveMessage: 'Save template failed.', saveSnackbarDuration: null });
      });

    } else {
      let greeting = this.state.greeting;
      if (!greeting) {
        greeting = template.greeting;
      }
      let body = this.state.body;
      if (!body) {
        body = template.body;
      }

      CommunicationTemplateCreateMutation.commit(accountId, this.state.usingAccountId, template.templateName, greeting, body)
      .then(response => {
        this.setState({ forceFetch: forceFetch, showSpinner: false, saveSnackbarOpen: true, saveStatus: 'success', saveMessage: 'Template saved.', saveSnackbarDuration: 3000 });
      })
      .catch(error => {
        this.setState({ forceFetch: forceFetch, showSpinner: false, saveSnackbarOpen: true, saveStatus: 'error', saveMessage: 'Save template failed.', saveSnackbarDuration: null });
      });


    }

   
  }

}




export default withStyles(styleSheet)(CommunicationTemplate);
